<template>
  <div class="b-product-modal-content">
    <b-row>
      <b-col offset-lg="1" sm="12" lg="5" class="product-images-container">
        <b-img :src="product.featured_image" fluid center />
      </b-col>

      <b-col offset-lg="1" sm="12" lg="5" class="product-details-container">
        <b-row>
          <b-col cols="12">
            <span class="brand-name">{{ product.brand_name }}</span>
          </b-col>

          <b-col cols="12">
            <span class="product-name">{{ product.name }}</span>
          </b-col>

          <b-col cols="12">
            <span class="product-price mt-2">{{ formattedPrice }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div class="d-flex justify-content-between mt-5 mb-4">
              <div v-if="currentUser !== null">
                <AddRemoveWardrobeDropdown
                  :productId="productId"
                  :wardrobeId="currentUser.wardrobe_id"
                  :similar="ownsSimilar"
                  :group="group"
                />
              </div>

              <div>
                <b-button
                  class="btn-sm"
                  variant="unstitched"
                  target="_blank"
                  rel="noopener noreferrer"
                  :href="product.url"
                >
                  Buy
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>

        <div role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <b-btn
                block
                href="#"
                class="tab-header text-left"
                v-b-toggle.editors_notes
              >
                Editors Notes
                <span class="float-right expand-plus">×</span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="editors_notes"
              visible
              accordion="product-details-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <p class="card-text" v-html="product['editors_comments']"></p>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <b-btn
                block
                href="#"
                class="tab-header text-left"
                v-b-toggle.size_fit
              >
                Size & Fit
                <span class="float-right expand-plus">×</span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="size_fit"
              accordion="product-details-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <p class="card-text" v-html="product['size_fit']"></p>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-0" role="tab">
              <b-btn
                block
                href="#"
                class="tab-header text-left"
                v-b-toggle.details_care
              >
                Details & Care
                <span class="float-right expand-plus">×</span>
              </b-btn>
            </b-card-header>

            <b-collapse
              id="details_care"
              accordion="product-details-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <p class="card-text" v-html="product['details_care']"></p>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Dinero from "dinero.js";
import AddRemoveWardrobeDropdown from "@/components/wardrobe/AddRemoveWardrobeDropdown";
import { mapActions, mapGetters } from "vuex";

export default {
  mounted() {
    if (this.currentUser !== null && this.product) {
      const payload = {
        wardrobeId: this.currentUser.wardrobe_id,
        productId: this.product.id
      };

      this.fetchCurrentWardrobeProduct(payload);
    }
  },

  beforeDestroy() {
    this.setCurrentWardrobeProduct(null);
  },

  components: {
    AddRemoveWardrobeDropdown
  },

  props: {
    product: {
      type: Object,
      required: true
    },

    group: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loadingData: true
    };
  },

  computed: {
    ...mapGetters(["currentUser", "currentWardrobeProduct"]),

    formattedPrice() {
      this.product;
      const locale = this.product.price_currency;
      const value = this.product.price_cents;

      return Dinero({ amount: value, currency: locale }).toFormat("$0,0.00");
    },

    ownsSimilar() {
      return this.currentWardrobeProduct
        ? this.currentWardrobeProduct.similar
        : null;
    },

    productId() {
      if (this.product) return this.product.id;
    }
  },

  methods: {
    ...mapActions(["fetchCurrentWardrobeProduct", "setCurrentWardrobeProduct"])
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.btn:focus {
  box-shadow: none;
}

.btn-buy {
  font-size: 1.5rem;
  font-weight: 100;
}

.brand-name,
.product-price,
.product-name {
  color: $grey1;
}

.brand-name {
  font-weight: 400;
  font-size: 1.4rem;
}

.product-name {
  font-size: 0.9rem;
  font-weight: 300;
}

.product-price {
  font-size: 0.9rem;
  font-weight: 300;
}

.card {
  box-shadow: none;
}

.card-header {
  border-bottom: none;
}

.expand-plus {
  margin-top: -5px;
  font-size: 1rem;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  -webkit-transition: all 0.5s ease-in-out;
  transition: all 0.5s;
}

.collapsed {
  .expand-plus {
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
}

.tab-header {
  color: $primary-blue;
  background-color: transparent;
  border-radius: 0;

  &:not(.collapsed) {
    background-color: $primary-blue;
    color: white;
  }

  &:hover {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsule/ProductModalContent.vue